import { axiosApiInstance } from './axios';

// -------------------------------------------------------------

const apiRoot = '';

const tobaccoProductionsApi = {
  // GET
  get: async (params) => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/conveyorTobaccoProduction/byDates`, { params });

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  getTobaccoConveyorSteps: async () => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/conveyorTobaccoProduction/tobaccoConveyorSteps/`);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },

  getTobaccoConveyorStepsV2: async () => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/conveyorTobaccoProduction/tobaccoConveyorSteps/v2`);

      return res;
    } catch (e: any) {
      return e.response;
    }
  },
};

export default tobaccoProductionsApi;
